import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  TextField,
  CardContent,
  Grid,
  Button,
  Chip,
  CircularProgress,
} from "@mui/material";
import { Box } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import axios from "axios";
import Key from "../../../clientVariables.json";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { getCandidateDetailAction } from "../redux/action";
import { myCandidatesSelector } from "../redux/selector";
import { userSelector } from "../../user-redux/selector";

const RelatedTitles = ({ formDataHnadler }) => {
  const { candidateDetails } = useSelector(myCandidatesSelector);

  const [formData, setFormData] = useState({
    relatedTitles:
      candidateDetails?.related_titles !== "" &&
      candidateDetails?.related_titles !== null &&
      candidateDetails?.related_titles !== undefined
        ? candidateDetails?.related_titles?.split(",")
        : [],
    newRelatedTitles: "",
  });
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    setFormData({
      ...formData,
      relatedTitles:
        candidateDetails?.related_titles !== "" &&
        candidateDetails?.related_titles !== null &&
        candidateDetails?.related_titles !== undefined
          ? candidateDetails?.related_titles?.split(",")
          : [],
    });
  }, [candidateDetails]);

  useEffect(() => {
    formDataHnadler(
      {
        relatedTitles: formData.relatedTitles,
      },
      "f5"
    );
  }, []);

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleAddSkill = () => {
    if (formData.newRelatedTitles.trim() !== "") {
      if (formData.relatedTitles.length < 500) {
        setFormData({
          ...formData,
          relatedTitles: [
            ...formData.relatedTitles,
            formData.newRelatedTitles.trim(),
          ],
          newRelatedTitles: "",
        });
      } else {
        // setSnackbarOpen(true);
        handleOpenSnackbar("You can add up to 5 related titles.", "error");
      }
    }
  };

  const handleRemoveSkill = (index) => {
    const updatedSkills = formData?.relatedTitles?.filter(
      (_, i) => i !== index
    );
    setFormData({
      ...formData,
      relatedTitles: updatedSkills,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    await formDataHnadler(
      {
        relatedTitles: formData.relatedTitles,
      },
      "f5"
    );

    try {
      const response = await axios.post(
        `${Key.domain}/candidate/update/other/${candidateDetails?.candidate_id}`,
        {
          related_titles: formData.relatedTitles.join(","),
        }
      );

      if (response.data.data.msg === "Updated Successfully") {
        getCandidateDetailAction(candidateDetails?.candidate_id, user?.id)
        handleOpenSnackbar("related titles updated successfully", "success");
      } else {
        handleOpenSnackbar("Something went wrong", "error");
      }
    } catch (error) {
      console.error(error);
      handleOpenSnackbar("Something went wrong", "error");
    }
    setIsSubmitting(false);
  };
  const HandleRealtedTitles = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddSkill();
    } else if (e === "Add") {
      handleAddSkill();
    }
  };

  return (
    <Card sx={cardStyles}>
      <CardHeader
        title={
          <Typography variant="h6" sx={headerStyles}>
            Update Related Titles
          </Typography>
        }
      />
      <CardContent
        sx={{
          ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
            padding: "8px 6px",
          },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Related Titles
                </Typography>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Grid item xs={10}>
                    <TextField
                      id="relatedTitles"
                      label=""
                      fullWidth
                      variant="outlined"
                      placeholder="Type a title and press Enter"
                      value={formData.newRelatedTitles}
                      onChange={handleInputChange("newRelatedTitles")}
                      // onKeyPress={(e) => {
                      //   if (e.key === "Enter") {
                      //     e.preventDefault();
                      //     handleAddSkill();
                      //   }
                      // }}
                      onKeyPress={(e) => HandleRealtedTitles(e)}
                      sx={inputStyles}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Button onClick={() => HandleRealtedTitles("Add")}>
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              {formData?.relatedTitles?.map((skill, index) => (
                <Chip
                  key={index}
                  label={skill}
                  onDelete={() => handleRemoveSkill(index)}
                  sx={{ margin: "4px" }}
                />
              ))}
            </Grid>

            {/* <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <InfoOutlined sx={{ fontSize: "16px", color: "rgb(102, 120, 156)" }} />
                <Typography paragraph sx={{ fontSize: "14px", color: "rgb(102, 120, 156)", margin: 0 }}>
                  You can add up to 5 titles
                </Typography>
              </Box>
            </Grid> */}

            <Grid item xs={12} textAlign="end">
              <Button
                type="submit"
                variant="contained"
                sx={{ bgcolor: "#406882" }}
              >
                {isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="You can add up to 5 related titles."
      /> */}
    </Card>
  );
};

export default RelatedTitles;

const cardStyles = {
  boxShadow: "none",
  borderRadius: "8px",
};

const headerStyles = {
  color: "rgb(102, 120, 156)",
  fontSize: "16px",
  fontWeight: 600,
};

const labelStyles = {
  color: "rgb(160, 171, 184)",
};

const inputStyles = {
  border: "1px solid 	rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid 	rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
